import { useSnackbar } from 'notistack';
import { Navigate, Outlet } from 'react-router-dom';

import { Roles } from '@/utils/roles';
import { useAuthContext } from '@/hooks/useAuthContext';

type AuthGuardProps = {
  roles: number[];
};

export default function RolesGuard({ roles }: AuthGuardProps) {
  const { isInitialized, user } = useAuthContext();
  const newRoles = [...roles];
  newRoles.push(Roles.SUPER_ADMIN, Roles.OWNER_SOFT);
  const { enqueueSnackbar } = useSnackbar();

  if (!user?.role || !newRoles.includes(user?.role?.id ?? '')) {
    enqueueSnackbar('No cuentas con los permisos suficientes', {
      variant: 'warning',
      autoHideDuration: 2000,
    });
    return <Navigate to="/dashboard/app" />;
  }

  return <Outlet />;
}
